module.exports = __webpack_public_path__ + "static/media/Glenn.38f1c6c1.png";